module.exports = __webpack_public_path__ + "img/CTWP__Shield_03.d4c63ce0.png";